import * as Yup from 'yup';

export const StarFilterSchema = Yup.object().shape({
    rating: Yup.string(),
});

export type StarFilterDataType = Yup.InferType<typeof StarFilterSchema>;

type InitialValues = {
    rating: string;
};

export const StarFilterSchemaInitialValues: InitialValues = {
    rating: 'All',
};
